import { Button } from 'canoe';
import React from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide';

const Wrapper = styled.div`
  top: 35px;
  left: 206px;
  display: flex;
  flex-direction: column;
  align-items: center;

  z-index: 2;

  background: ${colors('white')};
  border-radius: 4px;
  min-height: 334px;
  margin: 20px;
  box-shadow: 0px 26px 50px -29px rgb(0 0 0 / 42%);

  width: 320px;
  position: absolute;

  border: 1px solid #d4d8e4;

  padding: 16px;

  &:after,
  &:before {
    content: '';
    height: 0;
    position: absolute;
    width: 0;
  }

  &:after {
    border-bottom: 10px solid ${colors('white')};
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    left: 50px;
    top: -10px;
  }
  &:before {
    border-bottom: 12px solid ${colors('neutral', 3)};
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    left: 49px;
    top: -12px;
  }
`;

const CloseButton = styled(Button)`
  margin-top: auto;
`;

interface NoVariablesProps {
  onClose: () => void;
}

export const NoVariables = ({ onClose }: NoVariablesProps) => {
  return (
    <Wrapper data-cy="variables-none-available">
      <div id="variables-no-traits-mount" />
      <CloseButton fullWidth onClick={onClose}>
        Got It!
      </CloseButton>
    </Wrapper>
  );
};
